/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ remaining: NonNullable<unknown> }} Admin_Ai_Chat_Tokens_LowInputs */

const en_admin_ai_chat_tokens_low = /** @type {(inputs: Admin_Ai_Chat_Tokens_LowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You have ${i?.remaining} tokens left this month`)
};

const de_admin_ai_chat_tokens_low = /** @type {(inputs: Admin_Ai_Chat_Tokens_LowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du hast diesen Monat noch ${i?.remaining} Tokens`)
};

const es_admin_ai_chat_tokens_low = /** @type {(inputs: Admin_Ai_Chat_Tokens_LowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Te quedan ${i?.remaining} tokens este mes`)
};

const fr_admin_ai_chat_tokens_low = /** @type {(inputs: Admin_Ai_Chat_Tokens_LowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Il vous reste ${i?.remaining} tokens ce mois-ci`)
};

const nl_admin_ai_chat_tokens_low = /** @type {(inputs: Admin_Ai_Chat_Tokens_LowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Je hebt deze maand nog ${i?.remaining} tokens`)
};

/** @type {(inputs: Admin_Ai_Chat_Tokens_LowInputs) => LocalizedString} */
const it_admin_ai_chat_tokens_low = en_admin_ai_chat_tokens_low;

/** @type {(inputs: Admin_Ai_Chat_Tokens_LowInputs) => LocalizedString} */
const pt_br2_admin_ai_chat_tokens_low = en_admin_ai_chat_tokens_low;

/** @type {(inputs: Admin_Ai_Chat_Tokens_LowInputs) => LocalizedString} */
const pl_admin_ai_chat_tokens_low = en_admin_ai_chat_tokens_low;

/** @type {(inputs: Admin_Ai_Chat_Tokens_LowInputs) => LocalizedString} */
const hu_admin_ai_chat_tokens_low = en_admin_ai_chat_tokens_low;

/** @type {(inputs: Admin_Ai_Chat_Tokens_LowInputs) => LocalizedString} */
const ro_admin_ai_chat_tokens_low = en_admin_ai_chat_tokens_low;

/**
* | output |
* | --- |
* | "You have {remaining} tokens left this month" |
*
* @param {Admin_Ai_Chat_Tokens_LowInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_ai_chat_tokens_low = /** @type {((inputs: Admin_Ai_Chat_Tokens_LowInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Ai_Chat_Tokens_LowInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_ai_chat_tokens_low(inputs)
	if (locale === "de") return de_admin_ai_chat_tokens_low(inputs)
	if (locale === "es") return es_admin_ai_chat_tokens_low(inputs)
	if (locale === "fr") return fr_admin_ai_chat_tokens_low(inputs)
	if (locale === "nl") return nl_admin_ai_chat_tokens_low(inputs)
	if (locale === "it") return it_admin_ai_chat_tokens_low(inputs)
	if (locale === "pt-BR") return pt_br2_admin_ai_chat_tokens_low(inputs)
	if (locale === "pl") return pl_admin_ai_chat_tokens_low(inputs)
	if (locale === "hu") return hu_admin_ai_chat_tokens_low(inputs)
	return ro_admin_ai_chat_tokens_low(inputs)
});
export { admin_ai_chat_tokens_low as "admin.ai_chat.tokens_low" }